<button [class]="computedClass()" [disabled]="disabled()">
  @if (variant() === 'icon') {
    <div class="w-4 h-4"><div [innerHTML]="getSvg()['chevron-down']"></div></div>
  } @else {
    <ng-content></ng-content>
  }
</button>
